import styled from 'styled-components';

import { COLORS } from '../../../../theme/tokens';
import { Text } from '../../../../components/Text/Text';

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

/** The image the copy below is describing, at the cover's own 16:9 crop. */
export const Preview = styled.img`
  width: 100%;
  aspect-ratio: 16 / 9;
  object-fit: cover;
  border-radius: 12px;
  border: 1px solid ${COLORS.panelBorder};
`;

export const Hint = styled(Text)`
  display: block;
  font-size: 12px;
  line-height: 1.5;
  color: ${COLORS.textFaint};
  margin-top: -6px;
`;
